<template>
  <div>
    <button
      v-if="!isOpen"
      class="fixed bottom-4 right-4 inline-flex items-center justify-center text-sm font-medium disabled:pointer-events-none disabled:opacity-50 border rounded-full w-16 h-16 hover:bg-gray-700 m-0 cursor-pointer border-gray-200 bg-none p-0 normal-case leading-5 hover:text-gray-900"
      type="button"
      style="background-color: rgb(218, 146, 136) "
      aria-haspopup="dialog"
      aria-expanded="false"
      data-state="closed"
      @click="isOpen = true"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-white block border-gray-200 align-middle"
      >
        <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" class="border-gray-200"></path>
      </svg>
    </button>

    <div
      v-else
      style="box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);"
      class="fixed bottom-[calc(4rem+1.5rem)] right-4 bg-white p-6 rounded-lg border border-[#e5e7eb] w-[calc(100vw-2rem)] max-w-[440px] h-[70vh] max-h-[634px] sm:right-0 sm:mr-4 sm:h-[634px] flex flex-col"
    >
      <div class="flex justify-between items-start pb-6">
        <div class="flex flex-col space-y-1.5">
          <h2 class="font-semibold text-lg tracking-tight">Chatbot</h2>
          <p class="text-sm text-[#6b7280] leading-3">Powered by JOMOE</p>
        </div>
        <button class="text-gray-500" @click="isOpen = false">×</button>
      </div>

      <div class="pr-4 flex-1 overflow-y-auto" style="min-width: 100%; display: table;">
        <div class="flex gap-3 my-4 text-gray-600 text-sm flex-1">
          <span class="relative flex shrink-0 overflow-hidden rounded-full w-8 h-8">
            <div class="rounded-full bg-gray-100 border p-1">
              <svg
                stroke="none"
                fill="black"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                aria-hidden="true"
                height="20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
                ></path>
              </svg>
            </div>
          </span>
          <p class="leading-relaxed">
            <span class="block font-bold text-gray-700">JOMOE</span>Hi, how can I help you today?
          </p>
        </div>

        <div v-if="!userInput" class="flex flex-wrap gap-2 my-4 text-sm">
          <button
            class="bg-gray-800 text-white px-3 py-1 rounded"
            @click="selectOption('email')"
          >
            Email us
          </button>
          <button
            class="bg-gray-800 text-white px-3 py-1 rounded"
            @click="selectOption('phone')"
          >
            Call us
          </button>
        </div>
        
        <div v-if="userInput" class="flex gap-3 my-4 text-gray-600 text-sm flex-1">
          <span class="relative flex shrink-0 overflow-hidden rounded-full w-8 h-8">
            <div class="rounded-full bg-gray-100 border p-1">
              <svg
                stroke="none"
                fill="black"
                stroke-width="0"
                viewBox="0 0 16 16"
                height="20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"
                ></path>
              </svg>
            </div>
          </span>
          <p class="leading-relaxed">
            <span class="block font-bold text-gray-700">You </span>{{ userInput }}
          </p>
        </div>

        <div v-if="aiResponse" class="flex gap-3 my-4 text-gray-600 text-sm flex-1">
          <span class="relative flex shrink-0 overflow-hidden rounded-full w-8 h-8">
            <div class="rounded-full bg-gray-100 border p-1">
              <svg
                stroke="none"
                fill="black"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                aria-hidden="true"
                height="20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
                ></path>
              </svg>
            </div>
          </span>
          <p class="leading-relaxed">
            <span class="block font-bold text-gray-700">JOMOE </span>{{ aiResponse }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatBot',
  data() {
    return {
      isOpen: false,
      inputText: '',
      userInput: '',
      aiResponse: ''
    };
  },
  methods: {
    selectOption(option) {
      if (option === 'email') {
        this.userInput = 'Email';
        this.aiResponse = 'You can reach us at info@jomoe.co.uk.';
        return;
      }

      if (option === 'phone') {
        this.userInput = 'Phone';
        this.aiResponse = 'You can call us at 07857840607.';
      }
    }
  }
};
</script>
